import DomComponent from '../lib/domComponent';
import { each, mq, isMobileSafari } from '../lib/util';

var $ = window.$;

const COOKIE_BANNER_ID = 'pi_tracking_opt_in_div';


export default class HeaderComponent extends DomComponent {
    static selector = '[data-js-header]';
    el;

    constructor(el) {
        // return false
        super(el);
        this.body = document.querySelector('body');
        this.$el = $(el);
        this.$topLevelListItems = this.$el.find('[data-js-top-level-li]');
        this.$secondLevelMenu = this.$el.find('[data-js-second-level-menu]');
        this.$secondLevelListItems = this.$el.find('[data-js-second-level-li]');
        this.$thirdLevelMenu = this.$el.find('[data-js-third-level-menu]');

        // this.level1Items = this.$el.find('[data-js-level1-li]');
        // this.level2Items = this.$el.find('[data-js-level2-li]');
        this.$searchButton = this.$el.find('[data-search-trigger]');
        this.$searchInput = this.$el.find('[data-search-input]');
        this.$closeSearch = this.$el.find('[data-close-search]');
        this.$search = this.$el.find('[data-search]');
        this.$mobileMenuTrigger = this.$el.find('[data-mobile-menu-trigger]');
        this.$mobileMenu = this.$el.find('[data-mobile-menu]');
        this.$mobileMenuItems = this.$el.find('[data-header-mobile-item]');
        this.$subMobileMenuItems = this.$el.find('[data-header-mobile-submenu-item] > a, [data-header-mobile-submenu-item] > .header__menu__text');
        this.$mobileSearch = this.$el.find('[data-mobile-search]');


        this.$mobileMenuTrigger.on('click', function(e){
            const $currentTarget = $(e.currentTarget);
            if($currentTarget.hasClass('active')) {
                $currentTarget.removeClass('active');
                this.$mobileMenu.removeClass('open');
                this.body.classList.remove('no-scroll');
            } else{
                $currentTarget.addClass('active');
                this.$mobileMenu.addClass('open');
                this.body.classList.add('no-scroll');
            }
        }.bind(this));

        this.$searchButton.on('click', function(e) {
            this.handleSearchClick();
        }.bind(this));

        this.$closeSearch.on('click', function(e){
            this.$search.removeClass('active');
            this.$searchButton.attr('type', 'button');
        }.bind(this));

        each(this.$topLevelListItems, (listItem) => {
            $(listItem).on('mouseover', function(e){
                this.adjustSecondLevelMenuLeft(e.currentTarget);
            }.bind(this));
        });

        each(this.$secondLevelListItems, (listItem) => {
            $(listItem).on('mouseover', function(e){
                this.adjustThirdLevelMenuLeft(e.currentTarget);
                this.adjustThirdLevelMenuHeight(e.currentTarget);
            }.bind(this));
        });

        each(this.$mobileMenuItems, (listItem) => {
            $(listItem).on('click', function(e){
                const $currentTarget = $(e.currentTarget),
                    $target = $(e.target);
                if ($target.is("a")) {
                    e.stopPropagation();
                    return;
                }
                if($currentTarget.has('[data-header-mobile-submenu]').length){
                    e.preventDefault();
                    if($currentTarget.hasClass('active')){
                        $currentTarget.find('[data-header-mobile-submenu]').slideUp();
                        $currentTarget.removeClass('active');
                    } else {
                        $currentTarget.find('[data-header-mobile-submenu]').slideDown();
                        $currentTarget.addClass('active');
                    }
                }
            });
        });

        each(this.$subMobileMenuItems, (listItem) => {
            $(listItem).on('click', function(e){
                e.stopPropagation();
                const $currentTarget = $(e.currentTarget);
                if($(e.currentTarget).next().hasClass('header__mobile__subsubmenu')){
                    e.preventDefault();
                    if($currentTarget.hasClass('active')){
                        $currentTarget.next().slideUp();
                        $currentTarget.removeClass('active');
                    } else {
                        $currentTarget.next().slideDown();
                        $currentTarget.addClass('active');
                    }
                }
            }.bind(this));
        });

        setTimeout(() => {
            // $('body').css('padding-top', cookieBannerHeight);
            this.checkForCookieBanner();
            this.loaded();
        });
    }

    adjustSecondLevelMenuLeft(targetElm){
        const $target = $(targetElm);
        const $secondLevelMenu = $target.find('[data-js-second-level-menu]');
        if($secondLevelMenu.length > 0){
            if($secondLevelMenu.is(':offscreen')){
                const $rect = $secondLevelMenu.offset();
                const newLeft = $(window).width() - ($rect.left + this.$secondLevelMenu.width());

                $secondLevelMenu.css('left', `${newLeft}px`);
            }
        }
    }

    adjustThirdLevelMenuLeft(targetElm){
        const $target = $(targetElm);
        const $thirdLevelMenu = $target.find('[data-js-third-level-menu]');
        if($thirdLevelMenu.length > 0){
            if($thirdLevelMenu.is(':offscreen')){
                const rect = $thirdLevelMenu.get(0).getBoundingClientRect();
                $thirdLevelMenu.css({'left': `-${rect.width}px`, 'width':`${rect.width}px`});
            }
        }
    }

    adjustThirdLevelMenuHeight(targetElm){
        const $target = $(targetElm);
        const $thirdLevelMenu = $target.find('[data-js-third-level-menu]');
        if($thirdLevelMenu.length > 0){
            const $secondLevelMenu = $target.parent();
            if($thirdLevelMenu.height() < $secondLevelMenu.height()){
                const height = $secondLevelMenu.height();
                $thirdLevelMenu.height(height);
            }
        }
    }

    handleSearchClick(){
        const isDesktop = mq('md');
        this.$searchInput.focus();
        if(isDesktop){
            this.$search.addClass('active');
            setTimeout(() => {
                this.$searchButton.attr('type', 'submit');
            })
        } else{
            if(this.$mobileSearch.hasClass('open')){
                this.$mobileSearch.removeClass('open');
                this.$searchButton.find('i').removeClass('icomoon--Close').addClass('icomoon--Search');
            } else{
                this.$mobileSearch.addClass('open');
                this.$searchButton.find('i').removeClass('icomoon--Search').addClass('icomoon--Close');
            }
        }
    }

    // the following function checks for the existence of the Pardot cookie banner
    // Because this snippet of HTML is dependent on a pardot script that loads async, and because pardot naturally does not have any callback functionality
    // we need to check for mutations on the document body via new elements being inserted.
    checkForCookieBanner() {
        if (this.hasPardotCookie()) {
            return;
        }
        this.$cookieBanner = $(`#${COOKIE_BANNER_ID}`);
        if (!this.$cookieBanner.length) {
            const observer = new MutationObserver((mutations) => {
                this.$cookieBanner = $(`#${COOKIE_BANNER_ID}`);
                if (this.$cookieBanner.length) {
                    this.handleCookieBanner()
                    observer.disconnect();
                }
            });
            observer.observe(document.body, {attributes: false, childList: true, characterData: false })
        }
        else {
            this.handleCookieBanner();
        }
    }

    // because the cookie banner is fixed, push the header and body down to accommodate the banner
    handleCookieBanner() {
        this.$cookieBanner.addClass('active');
        const cookieBannerHeight = this.$cookieBanner.outerHeight();
        $('body').css('padding-top', `${cookieBannerHeight}px`);
        $('.header.layout__header').css('top', `${cookieBannerHeight}px`);

        $('a', this.$cookieBanner).on('click', () => {
            this.$cookieBanner.hide();
            $('body').css('padding-top', '0px');
            $('.header.layout__header').css('top', '0px');
        });
    }

    hasPardotCookie() {
        const cookies = document.cookie.split(';');
        for (var i = 0 ; i <= cookies.length; i++) {
            if (cookies[i] != null && cookies[i].indexOf('pi_opt_in') !== -1) {
                return true;
            }
        }
        return false;
    }
}
